import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-emerald-500 to-teal-600">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Başlamaya Hazır mısınız?
        </h2>
        <p className="text-emerald-100 text-lg mb-10 max-w-xl mx-auto">
          Özelleştirilebilir ve tamamen izlenebilir QR kodlarınızı bugün oluşturun. Ücretsiz deneyin.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/generator"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white text-emerald-600 font-bold rounded-full hover:bg-emerald-50 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-qr-code-line"></i>
            Ücretsiz QR Kod Oluştur
          </Link>
          <Link
            to="/pricing"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border-2 border-white/50 text-white font-semibold rounded-full hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
          >
            Planları İncele
          </Link>
        </div>
      </div>
    </section>
  );
}
